/**
 * @generated SignedSource<<43016cfc75bb274c47198453e461388e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageEditForm_page$data = {
  readonly id: string;
  readonly name: string;
  readonly text: string | null;
  readonly " $fragmentType": "PageEditForm_page";
};
export type PageEditForm_page$key = {
  readonly " $data"?: PageEditForm_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageEditForm_page">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageEditForm_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "type": "Page",
  "abstractKey": null
};

(node as any).hash = "c777daf777f80bfcf3295b4f670ab87a";

export default node;
